export enum NavigationOriginTypes {
  GESTOR = 'gestor',
  GESTOR_MANUAL_ACCESS = 'gestorManualAccess',
  IMPORTER = 'importador-de-captaciones',
  LIST = 'listado',
  LIST_MANUAL_ACCESS = 'listManualAccess',
  RESERVOMETRO = 'reservometro',
  RESERVOMETRO_MANUAL_ACCESS = 'reservometroManualAccess',
  RENDITION_PANEL = 'renditionpanel',
  STATS = 'stats',
  PENDING_LIST = 'pending-list',
}

export function getNavigationOriginCode(
  type: NavigationOriginTypes | undefined
): number {
  switch (type) {
    case NavigationOriginTypes.IMPORTER:
      return 1;
    case NavigationOriginTypes.GESTOR:
      return 3;
    case NavigationOriginTypes.LIST:
      return 4;
    case NavigationOriginTypes.RESERVOMETRO:
      return 5;
    default:
      return 2;
  }
}

// SIGNIFICADOS PARA BACKEND:
// 1 - Importador
// 2 - Manual
// 3 - Gestor
// 4 - Listado
// 5 - Reservometro
